import { render, staticRenderFns } from "./EspondiloartritesHypothesisPhase.vue?vue&type=template&id=61284d3a&scoped=true&"
import script from "./EspondiloartritesHypothesisPhase.vue?vue&type=script&lang=js&"
export * from "./EspondiloartritesHypothesisPhase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61284d3a",
  null
  
)

export default component.exports